// extracted by mini-css-extract-plugin
export default {"WorkPermitsList":"WorkPermitsList_WorkPermitsList__TShfN"};